import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import noop from 'lodash/noop';
import { getProPrefixCls as getProPrefixClsDefault } from 'choerodon-ui/lib/configure/utils';
import FilterSelect from './FilterSelect';
import ColumnFilter from './ColumnFilter';
import TableContext from '../TableContext';
import { $l } from '../../locale-context';
let TableFilterBar = class TableFilterBar extends Component {
    static get contextType() {
        return TableContext;
    }
    get prefixCls() {
        const { prefixCls } = this.props;
        const { tableStore: { getProPrefixCls = getProPrefixClsDefault } } = this.context;
        return getProPrefixCls('table', prefixCls);
    }
    renderSuffix() {
        const { prefixCls } = this;
        return React.createElement(ColumnFilter, { prefixCls: prefixCls });
    }
    getButtons() {
        const { buttons } = this.props;
        const { prefixCls } = this;
        if (buttons.length) {
            return (React.createElement("div", { key: "toolbar", className: `${prefixCls}-toolbar` },
                React.createElement("span", { className: `${prefixCls}-toolbar-button-group` }, buttons)));
        }
    }
    render() {
        const { dataSet, queryDataSet, paramName, placeholder = $l('Table', 'filter_bar_placeholder'), pagination, onQuery = noop, onReset = noop } = this.props;
        const { prefixCls } = this;
        const buttons = this.getButtons();
        return [
            buttons,
            pagination,
            React.createElement(FilterSelect, { key: "filter", prefixCls: `${prefixCls}-filter-select`, optionDataSet: dataSet, queryDataSet: queryDataSet, placeholder: placeholder, suffix: this.renderSuffix(), paramName: paramName, onQuery: onQuery, onReset: onReset }),
        ];
    }
};
TableFilterBar.defaultProps = {
    paramName: 'params',
};
TableFilterBar = __decorate([
    observer
], TableFilterBar);
export default TableFilterBar;
